import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
// import Contents from '../pages/Contents';
// import Dashboard from '../pages/Dashboard';
// import Font from '../Fonts/ITCEDSCR.TTF';
// import Mlogo from '../Images/rdfs007.jpg';
// import { FaRegIdBadge } from 'react-icons/fa';

const Navbar = ()=>{
    const [isOpen, setIsOpen] = useState(false);


    // if(`${isOpen && "open"}`){
        // setIsOpen(!isOpen);
    // }else{
        // setIsOpen(isOpen)
    // }

    return(
        <>
        <div className='navbar'>
            <div className={`nav-logo ${isOpen && "open"}`} style={{textShadow: '1px -3px 3px #ffa000'}} onClick={()=>setIsOpen(isOpen)}>
            <Link to="/contents"><span className='myname'>Rachna</span><span className='restname'>Digi Films</span></Link>
            </div>
            {/* <spacer/> */}
            <div className='nav-items'>
            {/* <Link to="/signup">SignUp</Link>                 */}
            </div>
            <div className={`nav-items ${isOpen && "open"}`} onClick={()=>setIsOpen(!isOpen)}>
                    {/* <Link to="/aboutus">About Us</Link> */}
                    <Link to="/">Home</Link>
                    <Link to="/dashboard">Dashboard</Link>
                    <Link to="/casting">Casting Calls</Link>
                    {/* <Link to="/gears">Our Gears</Link> */}
                    <Link to="/gallery">Gallery</Link>
                 {/* <div className='disappear' style={{position: 'absolute', left: '0', bottom: '2', paddingBottom1: '2%', height: '500px', width: '100%' }}> */}
                     {/* <div style={{height: '133px', marginBottom: '0', backgroundColor: 'blue'}}> */}
                     {/* <img src={Mlogo} style={{width: '100%', height: '100%'}} alt="Logo" /> */}
                     {/* </div> */}
                 {/* </div> */}
            </div>
            <div className={`nav-toggle ${isOpen && "open"}`} onClick={()=>setIsOpen(!isOpen)}>
                <div className='bar'></div>
            </div>
        
        </div>
            {/* <Contents /> */}
            {/* <div className='disappear' style={{height: '20%', backgroundColor:'red', bottom: '0' }}> */}
                     {/*  */}
            {/* </div> */}
            </>
    );

}

export default Navbar;